<template>
    <BootstrapModal ref="modal">

        <div class="modal-header pb-0">
            <CloseButton @click="dismiss" class="ml-auto"/>
        </div>

        <!-- report content form -->
        <div v-if="hasReported === false">
            <div class="modal-body">
                <div class="text-center mb-1"><i class="far fa-2x fa-exclamation-circle"></i></div>
                <h5 class="text-center mb-0">Report this {{ contentTypeLabel }}</h5>
                <p class="text-center mb-3">Let us know why you're reporting this content.</p>

                <div v-if="error" class="alert alert-danger">
                    <button @click="error = null" type="button" class="close">×</button>
                    {{ error }}
                </div>

                <div class="form-group">

                    <div class="my-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" name="reason" :id="`reason_spam_${contentType}_${contentId}`" value="spam" v-model="reason">
                            <label class="custom-control-label" :for="`reason_spam_${contentType}_${contentId}`">This content is spam</label>
                        </div>
                    </div>

                    <div class="my-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" name="reason" :id="`reason_tos_${contentType}_${contentId}`" value="tos" v-model="reason">
                            <label class="custom-control-label" :for="`reason_tos_${contentType}_${contentId}`">This content violates the Terms of Service or Community Guidelines</label>
                        </div>
                    </div>

                    <div class="my-2">
                        <div class="custom-control custom-radio">
                            <input type="radio" class="custom-control-input" name="reason" :id="`reason_other_${contentType}_${contentId}`" value="other" v-model="reason">
                            <label class="custom-control-label" :for="`reason_other_${contentType}_${contentId}`">Other</label>
                        </div>
                    </div>

                    <div v-if="hasError('reason')" v-for="error in errors['reason']" class="d-block invalid-feedback">
                        <i class="fa fa-exclamation-circle fa-fw"></i> {{ error }}
                    </div>

                </div>

                <div class="form-group">
                    <textarea ref="additional_information" id="additional_information" name="additional_information" class="form-control" rows="5" placeholder="Please give us as much information as possible for why you are reporting this content." v-model="additionalInformation"></textarea>
                    <div v-if="hasError('additional_information')" v-for="error in errors['additional_information']" class="d-block invalid-feedback">
                        <i class="fa fa-exclamation-circle fa-fw"></i> {{ error }}
                    </div>
                </div>

                <div class="form-group">
                    <button type="button" @click="report" class="btn btn-secondary w-100" :disabled="reason === null">
                        <span v-if="isReporting"><i class="fa fa-spin fa-spinner"></i> Reporting...</span>
                        <span v-else>Submit Report</span>
                    </button>
                </div>

            </div>
        </div>

        <!-- success -->
        <div v-if="hasReported === true">
            <div class="modal-body">
                <div class="text-center mb-1"><i class="fa fa-2x fa-check text-success"></i></div>
                <h5 class="text-center mb-0">Content Reported</h5>
                <p v-if="message" class="text-center mb-3">{{ message }}</p>
                <div class="form-group">
                    <button type="button" @click="dismiss" class="btn btn-secondary w-100">Dismiss</button>
                </div>
            </div>
        </div>

    </BootstrapModal>
</template>

<script>
    import BootstrapModal from "../Modals/BootstrapModal";
    import CloseButton from "../Modals/CloseButton";
    export default {
        components: {
            CloseButton,
            BootstrapModal,
        },
        data: function() {
            return {

                isReporting: false,
                hasReported: false,

                contentId: null,
                contentType: null,
                reason: null,
                additionalInformation: null,

                error: null,
                errors: {},
                message: null,

            }
        },
        methods: {
            hasError(key) {
                return Object.keys(this.errors).includes(key);
            },
            clearErrors() {
                this.error = null;
                this.errors = [];
            },
            show: function(contentId, contentType) {
                this.reset();
                this.contentId = contentId;
                this.contentType = contentType;
                this.$refs.modal.show();
            },
            reset: function() {
                this.isReporting = false;
                this.hasReported = false;
                this.contentId = null;
                this.contentType = null;
                this.reason = null;
                this.additionalInformation = null;
                this.error = null;
                this.errors = {};
                this.message = null;
            },
            dismiss: function() {
                this.$refs.modal.hide();
            },
            report: function() {

                // do nothing if already reporting
                if(this.isReporting){
                    return;
                }

                this.isReporting = true;

                // clear errors
                this.clearErrors();

                // submit report
                axios.post(route('web-api.v1.report'), {
                    content_id: this.contentId,
                    content_type: this.contentType,
                    reason: this.reason,
                    additional_information: this.additionalInformation,
                }).then((response) => {

                    const json = response.data;
                    this.message = json.message;
                    this.isReporting = false;
                    this.hasReported = true;

                }).catch((error) => {

                    this.isReporting = false;

                    // update errors
                    if(error.response?.data?.errors){
                        this.errors = error.response.data.errors;
                    } else {
                        this.error = error.response?.data?.message || error.response?.statusText || error;
                    }

                });

            }
        },
        computed: {
            contentTypeLabel: function() {
                switch(this.contentType){
                    case "post_comment": return "Comment";
                }
                return this.contentType;
            },
        },
    }
</script>
